<template>
    <div>
        <header-nav :cur="6" :loginstate="loginstate" />
        <!-- 搜索 -->
        <div class="nav">
            <div class="navtab">
                <span class="top">
                    <a href="/">首页</a>&nbsp;>&nbsp;
                    <span style="color: blue;">考试评估</span>
                </span>
                <div class="newbox">
                    <div>
                        <div class="newtop">考试评估</div>
                        <div class="newbot">帮助学员查漏补缺,提高学习效果</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 考试习题列表 -->
		<!-- 考试习题列表 -->
		<div class="navtab exerise" style="margin-top: 18px;">
			<el-table
			    :data="examList"
				class="my-custom-table"
			    border
			    style="width: 100%">
			    <el-table-column
			      prop="paperName"
			      label="考试信息">
			    </el-table-column>
				<el-table-column
				  prop="year"
				  label="年份">
				</el-table-column>
			    <el-table-column
			      prop="sTime"
			      label="开始时间">
			    </el-table-column>
			    <el-table-column
			      prop="eTime"
			      label="结束时间">
			    </el-table-column>
				<el-table-column
				  prop="fullScore"
				  label="满分">
				</el-table-column>
				<el-table-column
				  prop="passScore"
				  label="通过分数">
				</el-table-column>
				<el-table-column
				  prop="paperDescribe"
				  label="考试说明">
				</el-table-column>
				<el-table-column  label="操作"  aligh="center" width="100">
					<template slot-scope="scope">
						<el-button icon="el-icon-edit-outline" @click="joinExam(scope.row)" type="text" size="small" v-if="scope.row.maxScore<scope.row.passScore">参与考试</el-button>
						<el-button icon="el-icon-finished" type="text" size="small" v-if="scope.row.maxScore>=scope.row.passScore" style="color: blue;">考试合格</el-button>
					</template>
				</el-table-column>
			  </el-table>
		</div>
		<!-- 分页 -->
		 <v-pagination :total="total" :display='queryParams.pageSize' :current-page='queryParams.pageNum'
		               @pagechange="pagechange" style="padding-top: 80px;"></v-pagination>
        <footer-nav />
    </div>
</template>
<script>
import headerNav from '../../components/HeaderNav.vue';
import footerNav from '../../components/FooterBar';
import pagination from '@/components/common/pagination'
import {queryExamList} from '@/api/exam.js'
import {queryLoginState} from "@/api/login";
import {getExamById} from '@/api/exam.js'
export default {
	components: {
	    'header-nav': headerNav,
	    'footer-nav': footerNav,
		'v-pagination': pagination,
	},
    data() {
        return {
			loginstate:false,
			queryParams: {
			  pageNum: 1,
			  pageSize: 10,
			  year: null
			},
			total:0,
			examList:[]
        };
    },
	created() {
		this.queryLoginState();
		this.getList();
	},
    methods: {
		getList() {
		  this.loading = true;
		  this.queryParams.year = localStorage.getItem('year');
		  queryExamList(this.queryParams).then(response => {
		    this.examList = response.rows;
		    this.total = response.total;
		    this.loading = false;
		  });
		},
		joinExam(row){
			this.loading = true;
			getExamById(row.wid).then(response => {
				if(response.code == 200){
					this.$router.push({ path: '/startExam', query: { id: row.wid } });
				}
				this.loading = false;
			});
			
		},
        back() {
            this.$router.back(-1);
        },
        clickParentSubject(int,pid) {
            this.int = int;
			this.parentSubjectId=pid;
			this.querySubSubjectList(pid);
			this.queryExercises(1);
        },
		clickSubSubject(int,id) {
			this.subjectId=id;
		    this.subInt = int;
			this.queryExercises(1);
		},
        toexercise(id) {
            this.$router.push({ path: '/exam/exercise', query: { id: id } });
        },
		pagechange(currentPage) {
		  console.log(currentPage);
		  this.queryParams.pageNum = currentPage;
		  // ajax请求, 向后台发送 currentPage, 来获取对应的数据
		  this.getList();
		},
		queryLoginState() {
		  queryLoginState({}).then(res => {
		    if (res.code == 200) {
		      this.loginstate = true;
		      return;
		    } 
		  })
		},
    },
};
</script>
<style lang="less" scoped>
    // 公共
    .navtab {
        width: 1280px;
        margin: 0 auto;
    }
    .color {
        color: #2961EF !important;
    }
    .ignore {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
    }
    // 搜索
    .nav {
        background: #f7f8fa;
        width: 100%;
        height: 177px;
        .top {
            display: block;
            font-size: 16px;
    
            font-weight: 300;
            color: #777777;
            padding: 19px 0 24px;
            span {
                cursor: pointer;
            }
            .infor {
                color: #2961EF;
            }
        }
        .newbox {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .newtop {
                font-size: 26px;
                color: #000000;
                margin-bottom: 5px;
            }
            .newbot {
                font-size: 16px;
                color: #888888;
            }
            .input {
                width: 497px;
                height: 59px;
                background: #ffffff;
                box-shadow: 3px 3px 10px 1px rgba(11, 19, 72, 0.050980392156862744);
                border-radius: 30px;
                position: relative;
                input {
                    border: none;
                    position: absolute;
                    left: 30px;
                    top: 0;
                    height: 59px;
                    line-height: 59px;
                    width: 365px;
                    font-size: 16px;
    
                    font-weight: 300;
                    color: #777777;
                }
                .select {
                    position: absolute;
                    right: 12px;
                    top: 8px;
                    width: 74px;
                    height: 43px;
                    line-height: 43px;
                    background: #2961EF;
                    border-radius: 30px;
                    font-size: 16px;
    
                    font-weight: 300;
                    color: #ffffff;
                    text-align: center;
                }
            }
        }
    }
    // 学科分类
    .bacground {
        background: #f7f8fa;
    }
    .type {
        margin: 27px 0 0;
        padding: 14px 17px;
    
        border-radius: 5px 5px 0px 0px;
        border: 1px solid #e3e8f2;
        .ul {
            font-size: 16px;
            color: #333333;
            display: inline-block;
            vertical-align: text-top;
            width: 7%;
            margin-top: 3px;
        }
        ul {
            display: inline-block;
            vertical-align: text-top;
            // float: right;
            width: 93%;
            li {
                display: inline-block;
                font-size: 16px;
                color: #888888;
                margin-right: 30px;
                line-height: 30px;
            }
        }
        .add {
            margin-top: 15px;
        }
        .addul {
            margin-top: 18px;
        }
    }
    .brder {
        border-top: none;
        margin: 0 0 21px;
        border-radius: 0px 0px 0px 0px;
        .ul {
            margin-top: 3px;
        }
        .add {
            margin: 0;
        }
    }
    // 考试习题列表
    .exerise {
        display: flex;
        flex-wrap: wrap;
        margin: 35px auto 56px;
        .listbox {
            width: 21.5%;
            margin-bottom: 27px;
            // height: 145px;
            background: #fafafa;
            border-radius: 0px 0px 5px 5px;
            border-top: 3px solid #2961EF;
            margin-right: 1%;
            padding: 17px;
            &:nth-child(4n) {
                margin-right: 0;
            }
            .name {
                font-size: 18px;
                font-weight: 600;
                color: #333333;
            }
            .num {
                height: 35px;
                line-height: 35px;
                background: #ffffff;
                border-radius: 5px 5px 5px 5px;
                font-size: 15px;
                color: #999999;
                padding: 0 10px;
                margin: 15px 0;
                span {
                    height: 35px;
                    line-height: 35px;
                    margin: 0 0 0px 40px;
                    position: relative;
                    &::before {
                        content: '';
                        position: absolute;
                        left: -20px;
                        top: 2px;
                        display: inline-block;
                        width: 1px;
                        height: 16px;
                        background: #999999;
                    }
                }
            }
            .time {
                padding: 0 10px;
                font-size: 15px;
                color: #888888;
                span {
                    cursor: pointer;
                    font-size: 16px;
                    color: #2961EF;
                    float: right;
                }
            }
        }
    }

.my-custom-table {
	
	  &.el-table {
	    border: 1.2px solid #ebeef5;
	    border-radius: 8px; 
	    overflow: hidden; 
	
	    thead {
	      th {
	        background-color: #00aaff; 
	        color: #343a40; 
	        font-weight: 600;
	        border-bottom: 2px solid #2f4be6 !important;
	        transition: all 0.3s;
	        
	        &:first-child {
			  background-color: #00aaff;
	          border-radius: 8px 0 0 0; 
	        }
	        &:last-child {
	          border-radius: 0 8px 0 0; 
	        }
	        
	        &:hover {
	          background-color: #e9ecef;
	        }
	      }
	    }
	
	    /* 单元格样式 */
	    td {
	      border-bottom: 1px solid #dee2e6;
	    }
	
	    /* 行悬停效果 */
	    .el-table__row:hover td {
	      background-color: #f8f9fa !important;
	    }
	
	    /* 去除默认的右侧边框 */
	    &::before {
	      display: none;
	    }
	
	    /* 斑马纹效果（可选） */
	    &.el-table--striped .el-table__body tr.el-table__row--striped td {
	      background-color: #f8f9fa;
	    }
	
	    /* 滚动条样式（如果启用滚动） */
	    .el-table__body-wrapper::-webkit-scrollbar {
	      width: 6px;
	      background-color: #f5f5f5;
	    }
	  }
	
	  /* 调整单元格内边距 */
	  .cell {
	    padding: 12px 16px;
	  }
	
	  /* 表头阴影（可选） */
	  .el-table__header-wrapper {
	    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
	  }
	}
	
</style>